import { createAction } from 'redux-actions';
/**
 * Action that handles selecting an article from Ghost.
 *
 * This is used to ensure that the `useSelectedArticle` hook returns the correct article.
 *
 * ```js
 * // in a component
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 * // This is only necessary because of the hook, `selectArticle` doesn't use
 * // the ghost api.
 * const ghostApi = new GhostContentAPI({
 *   url: 'https://demo.ghost.io',
 *   key: 'abc123',
 *   version: "v3"
 * });
 *
 * const Test = () => {
 *   const { selectArticle } = ghost.hooks.useGhostActions(ghostApi);
 *   const onClick = () => {
 *     selectArticle('some-article-slug');
 *   }
 *
 *   return (
 *     <button onClick={onClick}>Click me</button>
 *   )
 * }
 *
 * // outside of a component
 * import { ghost } from '@minerva-analytics/pantheon';
 *
 * const anotherAction = () => async (dispatch) => {
 *   dispatch(ghost.actions.selectArticle('some-article-slug'));
 * };
 * ```
 *
 * @param {String} slug - The slug of the article to select
 *
 * @returns {Object} - A redux action that can be dispatched by redux.
 */

var selectArticle = createAction('SELECT_GHOST_ARTICLE');
export default selectArticle;